export const load = () => ({
	title: 'Window Inserts That Provide Comfort, Quiet, & Savings',
	description:
		'Indow makes window inserts that improve energy efficiency, comfort, and noise levels without the need to buy replacement windows.',
	showTitle: false,
});
